<template>
	<div class="section-overview">
		<div class="section-header">
			<div class="section-title is-small">
				Overview
			</div>
		</div>
		<div
			v-if="topCountry"
			class="section-body"
		>
			<div class="section-data">
				<div class="section-items">
					<div class="item-img">
						<img
							src="@/assets/click.png"
							alt="click"
						>
					</div>
					<div class="item">
						<div class="section-title is-small">
							{{ allTimeCountClicks }}
						</div>
						<div class="section-description is-medium">
							Total Clicks
						</div>
					</div>
				</div>
				<div class="section-items">
					<div class="item-img">
						<img
							src="@/assets/local.png"
							alt="click"
						>
					</div>
					<div class="item">
						<div class="section-title is-small">
							{{ topCountry.TopCountryEstimatedName }}
						</div>
						<div class="section-description is-medium">
							Top Location
						</div>
					</div>
				</div>
			</div>
			<AppSelect
				v-if="availableClickStatsCountries.length > 0"
				v-model="selectedClickStatsCountry.ISOCode"
				class="select-country"
				option-label="EstimatedName"
				option-value="ISOCode"
				:clearable="false"
				:options="availableClickStatsCountries"
				@input="onSelectCountry"
			/>
		</div>
		<div class="section-footer">
			<vChart
				:options="chartOptions"
				class="chart"
			/>
		</div>
		<div class="bg-color" />
	</div>
</template>

<script>
import 'echarts/lib/chart/bar';
import { mapActions, mapGetters } from 'vuex';
import vChart from 'vue-echarts/components/ECharts.vue';

export default {
	name: 'WidgetOverview',

	components: {
		vChart,
	},

	data() {
		return {
			selectedClickStatsCountry: {},
		};
	},

	computed: {
		...mapGetters([
			'clickStats',
			'topCountry',
			'availableClickStatsCountries',
			'allTimeCountClicks',
		]),
		chartOptions() {
			return {
				grid: {
					show: false,
					top: 40,
					left: 6,
					right: 6,
					bottom: 10,
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					scale: true,
					show: true,
					splitLine: {
						show: true,
						lineStyle: {
							color: '#33333a',
							width: 2,
						},
					},
					axisLabel: {
						color: '#8e8e92',
					},
				},
				yAxis: [
					{
						type: 'value',
						show: true,
						minInterval: 1,
						min: this.clickStats ? this.clickStats.YAxisMinValue : 0,
						max: this.clickStats ? this.clickStats.YAxisMaxValue : 10,
						splitLine: {
							show: true,
							lineStyle: {
								color: '#33333a',
							},
						},
						axisTick: {
							show: false,
						},
						axisLabel: {
							color: '#8e8e92',
						},
					},
				],
				series: [
					{
						type: 'bar',
						data: this.clickStats ? this.clickStats.XAxisValues.map((valuePair) => Object.values(valuePair)) : [],
						barWidth: 7,
						itemStyle: {
							color: '#1E75FF',
							barBorderRadius: 5,
						},
					},
				],
			};
		},
	},

	watch: {
		clickStats(clickStats) {
			this.selectedClickStatsCountry = {
				EstimatedName: clickStats.country.EstimatedName,
				ISOCode: clickStats.country.ISOCode,
			};
		},
	},

	mounted() {
		this.fetchClickStats();
	},

	methods: {
		...mapActions([
			'fetchClickStats',
			'fetchClickStatsByCountry',
		]),
		onSelectCountry(countryISOCode) {
			const country = this.availableClickStatsCountries.find((c) => c.ISOCode === countryISOCode);
			this.fetchClickStatsByCountry(country);
		},
	},
};
</script>

<style lang="scss" scoped>
.chart {
	width: 100%;
	height: 250px;
}

.section-overview {
	background-color: $color-accent-600;
	padding: $gap-5;
	margin-bottom: $gap-3;
	border-radius: 8px;
}

.section-header {
	padding: 0;
	margin: 0;
}

.select-country {
	width: 300px;
}

.section-body {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin: $gap-4 0;

	.section-data {
		display: flex;
		align-items: center;
	}

	.section-items {
		display: flex;
		align-items: center;
		margin-right: $gap-6;

		&:last-child {
			margin-right: 0;
		}
	}

	.item-img {
		width: 48px;
		height: 48px;
		margin-right: $gap-2;

		img {
			width: 100%;
			height: 100%;
		}
	}
}

.section-footer {
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: $gap-2;

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
}
</style>
